import React from "react";
import { motion } from "framer-motion";
import { FlameIcon } from "lucide-react";
import { scarcity } from "../data/offer";
export function ScarcityBar() {
  return <div className="mx-auto w-full max-w-xl rounded-2xl bg-coral-light p-4 ring-1 ring-coral/25" data-id="element-60" data-mp="2yy5nyvthfm87">
      <div className="flex items-center justify-between gap-3" data-id="element-61" data-mp="2l33exztc9gr6">
        <p className="flex items-center gap-2 text-[15px] font-bold text-coral-dark" data-id="element-62" data-mp="2q2g5aujf55yi">
          <FlameIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-63" data-mp="2b5yty3b8brby" />
          Only {scarcity.spotsLeft} spots left at the promo price
        </p>
        <span className="shrink-0 text-sm font-extrabold text-coral-dark" data-id="element-64" data-mp="2261ztm62m09i">{scarcity.percentClaimed}%</span>
      </div>
      <div className="mt-3 h-4 w-full overflow-hidden rounded-full bg-white ring-1 ring-coral/20" role="progressbar" aria-valuenow={scarcity.percentClaimed} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-65" data-mp="274n01llbojxy">
        <motion.div className="h-full rounded-full bg-coral" initial={{
        width: "0%"
      }} whileInView={{
        width: `${scarcity.percentClaimed}%`
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.9,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-66" data-mp="33mmu2ryk25uj" />
      </div>
      <p className="mt-2 text-xs text-ink/70" data-id="element-67" data-mp="38dv49q7plv8r">When these spots are gone, the price goes back up.</p>
    </div>;
}